angular.module('leanlaw').directive('entryFormErrorMessage', [function () {
  return {
    restrict: 'EA',
    scope: {
      entryForm: '=',
      me: '='
    },
    template: require("./views/entryFormErrorMessage.html"),
    controller: ["$scope", $scope => {
      $scope.getHoursError = function () {
        const value = parseFloat($scope.entryForm.hours.$viewValue);
        if (parseFloat(value.toFixed(2)) !== parseFloat(value)) {
          return "Time entries are limited to 2 decimal places.";
        }
        return `Your firm has Enforced Rounding enabled. Your Hours must be an increment of ${$scope.me.company.settings.timeEntryIncrement}.`;
      };
    }]
  };
}]);